// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"BO-z","carouselContainer":"CO-z"};